import * as React from 'react';
import ReactTable from 'react-table';
import { default as Renderers } from '../../sys/columns';
import { Button, Modal, Input, Checkbox, Dropdown, Grid } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus, DataRequest, TimeRange, RefreshFunctionSignature } from '../../api';
import CustomPagination from '../../sys/pagination';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-table/react-table.css';
import RequestParameters from '../../api/parameters';
import * as ReactTooltip from 'react-tooltip';
import * as moment from 'moment';
const fileDownload = require('js-file-download');

const _ = require('lodash');

interface LookupValue {
    key: number;
    value: string;
    text: string;
}

class State {
    data: any;
    groupby: Array<string>;
    startDate?: any;
    endDate?: any;
    assetFilter?: string;
    eventTypeFilter: string[];
    eventTypeFilterText: string[];
    eventTypeFilterAll: boolean;
    eventTypeClicked: boolean;
    assetVariants: LookupValue[];
    openModal ?: boolean;
    modalText: string;
    doRefresh: boolean;
    buttonText: string;
    refresh ?: number;
    firstLoad ?: boolean;
    exportBtnDisabled ?: boolean;
}

interface Props {
    location ?: any;
    streamName ?: string;
    header ?: boolean;
}

export default class TransactionLogView extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        streamName: '',
        header: true
    };
    private dataRefresh: RefreshFunctionSignature;
    componentWillMount() {
        this.setState({
            refresh: 10000,
            groupby: [],
            startDate: '',
            endDate: '',
            assetFilter: '',
            eventTypeFilter: [],
            eventTypeFilterText: [],
            eventTypeFilterAll: false,
            eventTypeClicked: false,
            assetVariants: [],
            openModal: false,
            modalText: '',
            doRefresh: true,
            buttonText: 'Pause',
            firstLoad: true,
            exportBtnDisabled: false
        });
        this.handleFilter = this.handleFilter.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.toggleRefreshHandler = this.toggleRefreshHandler.bind(this);
        this.clearLog = this.clearLog.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.setRefreshInterval = this.setRefreshInterval.bind(this);
        this.handleEventTypeCheckbox = this.handleEventTypeCheckbox.bind(this);
    }

    setRefreshInterval(interval?: number) {
        // tslint:disable-next-line:no-console
        this.setState({ refresh: interval }, () => console.log(this.state.refresh));
    }

    componentDidMount() {
        this.fetchAssets();
        this.setAssetFilterOnFirstLoad();
    }

    changeStream(streamName: string) {
        this.setState( {firstLoad: false, assetFilter: streamName } );
    }

    setAssetFilterOnFirstLoad() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);

        const { location } = this.props;
        // tslint:disable-next-line:no-unused-expression
        (this.state.firstLoad && location && location.state && location.state.name) && this.setState({assetFilter: location.state.name});
        // tslint:disable-next-line:no-unused-expression
        (this.state.firstLoad && this.props.streamName) && this.setState({assetFilter: this.props.streamName});
    }

    render() {
        const { location } = this.props;
        const { startDate, endDate, eventTypeFilter, doRefresh, buttonText } = this.state;
        const assetFilter = (this.state.firstLoad && location && location.state && location.state.name) ? location.state.name : this.state.assetFilter;
        const entryTypeOptions = [{ key: 'all', value: 'all', text: 'All' },
                                    { key: 'error', value: 'error', text: 'Errors' },
                                    { key: 'warning', value: 'warning', text: 'Warning' },
                                    { key: 'info', value: 'info', text: 'Informational' },
                                    { key: 'detail', value: 'detail', text: 'Details' }];

        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        const columns = [{
                width: 15
            }, {
                Header: 'Date/Time',
                accessor: 'timestamp',
                headerStyle: { textAlign: 'left' },
                width: 200,
                // resizable: false,
                aggregate: (values: any, row: any) => (values.length > 0) ? { min: _.min(values), max: _.max(values)  } : null,
                Cell: (props: any) => Renderers.timestamp.format(props.value),
                Aggregated: (row: any) => (
                    <span className="aggregated-timestamp">
                        {Renderers.timestamp.brief(row.value.min)} to {Renderers.timestamp.brief(row.value.max)}
                    </span>
                )
            }, {
                Header: 'Entry Type',
                accessor: 'type',
                headerStyle: { textAlign: 'left' },
                width: 160,
                // resizable: false,
                aggregate: (values: any, row: any) => (values.length > 0) ? _.uniq(values) : null,
                Cell: (props: any) => this.eventRenderer(props),
            }, {
                Header: 'Stream Name',
                accessor: 'name',
                headerStyle: { textAlign: 'left' },
                width: 300,
                // resizable: false,
                Cell: (props: any) => this.nameRenderer(props.value),
                Aggregated: (row: any) => { return null; }
            }, {
                Header: 'Type',
                accessor: 'streamType',
                headerStyle: { textAlign: 'left' },
                width: 105,
                // resizable: false,
                Cell: (props: any) => Renderers.streamType(props.value),
                Aggregated: (row: any) => null
            }, {
                Header: 'Detail',
                accessor: 'detail',
                headerStyle: { textAlign: 'left' },
                width: 1100,
                Cell: (props: any) => this.detailRenderer(props.value),
                Aggregated: (row: any) => { return null; }
            }];

        let params;
        if ((assetFilter.startsWith('\'') && assetFilter.endsWith('\'')) || (assetFilter.startsWith('\"') && assetFilter.endsWith('\"'))) {
            let tmpFilter = assetFilter.slice(1, assetFilter.length - 1);
            params = {
                timerange: new TimeRange({from: startDate, to: endDate}),
                type: (eventTypeFilter.length > 0) ? eventTypeFilter : undefined,
                exactName: tmpFilter
            };
        } else {
            params = {
                timerange: new TimeRange({from: startDate, to: endDate}),
                type: (eventTypeFilter.length > 0) ? eventTypeFilter : undefined,
                name: assetFilter
            };
        }

        return(
            <div className="view-content" id="txlog">
                {(this.props.header === true) ?
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Transaction Log</div>
                        </div>
                    </div>
                </div> : ''}
                {(this.props.header === true) ?
                <OAuth.Context>{(oauth: OAuthClientStatus) => (
                <div className="filterPanel-block">
                    <Grid relaxed columns={6} >
                        <Grid.Row>
                            <Grid.Column width={2}>
                                <DatePicker
                                    className="datePicker1SearchBox"
                                    todayButton={'Today'}
                                    placeholderText={'Start Time'}
                                    selected={startDate}
                                    value={this.state.startDate ? moment(this.state.startDate).format('LLL') : undefined}
                                    onChange={(date) => this.setState({startDate: date})}
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="LLL"
                                    isClearable={this.state.startDate ? true : false}
                                />
                            </Grid.Column>
                            <Grid.Column width={2}>
                                <DatePicker
                                    className="datePicker2SearchBox"
                                    todayButton={'Today'}
                                    placeholderText={'End Time'}
                                    selected={endDate}
                                    value={this.state.endDate ? moment(this.state.endDate).format('LLL') : undefined}
                                    onChange={(date) => this.setState({endDate: date})}
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeIntervals={15}
                                    dateFormat="LLL"
                                    isClearable={this.state.endDate ? true : false}
                                />
                            </Grid.Column>
                            <Grid.Column width={6}>
                                <React.Fragment>
                                    <Input
                                        className="objectPanelSearchBox"
                                        placeholder="Stream Name"
                                        value={assetFilter}
                                        onChange={(event, data) => this.changeStream(data.value)}
                                    />
                                </React.Fragment>
                    {/*<Dropdown*/}
                    {/*    className="eventTypeDropDown"*/}
                    {/*    placeholder="Entry Type"*/}
                    {/*    multiple*/}
                    {/*    search*/}
                    {/*    options={entryTypeOptions}*/}
                    {/*    value={eventTypeFilter}*/}
                    {/*    selection*/}
                    {/*    onChange={(event, data) => this.setState({ eventTypeFilter: data.value as string[] })}*/}
                    {/*/>*/}
                    {/*        </Grid.Column>*/}
                    {/*        <Grid.Column width={3}>*/}
                                <Dropdown
                                    className="eventTypeDropDown eventTypeDropDown-width300"
                                    // placeholder="Entry Type"
                                    multiple
                                    search
                                    labeled={false}
                                    searchInput={false}
                                    trigger={this.state.eventTypeFilterText.length > 0 ?
                                        <p className="eventTypeDropDownTrigger">{this.state.eventTypeFilterText.join(', ')}</p> :
                                        <p className="eventTypeDropDownTriggerLowOpacity">Entry Type</p>}
                                    selection
                                    /* tslint:disable-next-line:jsx-alignment */
                                 >
                                    <Dropdown.Menu>
                                        {entryTypeOptions.map(eOption => {
                                            // tslint:disable-next-line:jsx-key
                                            return  <Dropdown.Item>
                                                {/* tslint:disable-next-line:jsx-alignment */}
                                                    <Checkbox key={eOption.text}
                                                              /* tslint:disable-next-line:jsx-alignment */
                                                              label={<label className={this.state.eventTypeFilter.includes(eOption.value) || this.state.eventTypeFilterAll ? 'assetName' : ''}
                                                                            // SAN-4009 - The background color showed as green initially, this fix shows no background color
                                                                            /* tslint:disable-next-line:jsx-alignment */
                                                                            style={{backgroundColor: 'rgba(255,255,255, 0)'}}>{eOption.text}
                                                                  {/* tslint:disable-next-line:jsx-alignment */}
                                                                    </label>}
                                                              // label={eOption.text}
                                                              name={eOption.text}
                                                              checked={eOption.value === 'all' ?
                                                                  this.state.eventTypeFilterAll :
                                                                  this.state.eventTypeFilter.includes(eOption.value)}
                                                              onChange={(event, data) => this.handleEventTypeCheckbox(event, data, eOption, entryTypeOptions)}
                                                              style={{width: '100%'}}
                                                    />
                                                    </Dropdown.Item>;
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                                {/*<p className={'transaction-log-alias-search-note'}>Note: * - A preceding asterisk means the alias transaction log has been modified.</p>*/}
                            </Grid.Column>
                            {/*<Grid.Column width={1}>*/}
                            {/*    <div className="spacer"/>*/}
                            {/*</Grid.Column>*/}
                            <Grid.Column width={1} >
                                {/*<Button className="filterPanel-primary-btn" content="Filter" onClick={() => this.handleFilter()}/>*/}
                                <Button className="filterPanel-right-secondary-btn" content="Reset" onClick={() => this.handleReset()}/>
                            </Grid.Column>
                            <Grid.Column width={1} />
                            <Grid.Column textAlign={'right'} width={4}>
                                <Button className="filterPanel-right-primary-btn" content={buttonText} onClick={this.toggleRefreshHandler}/>
                                <Button
                                    className="filterPanel-secondary-btn"
                                    icon="file excel outline"
                                    content={this.state.exportBtnDisabled ? 'Exporting...' : 'Export'}
                                    disabled={this.state.exportBtnDisabled}
                                    onClick={(event, data) => this.exportLog(oauth)}
                                />
                                <OAuth.RequiresAdmin>
                                    <Button
                                        className="filterPanel-secondary-btn"
                                        content="Clear log"
                                        onClick={this.clearLog}
                                    />
                                </OAuth.RequiresAdmin>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
                )}</OAuth.Context> : ''}
                <div className="view-clientarea">
                    <DataRequest
                        auto                   // automatically request on data change (filter change)
                        spinner                // show spinner when foreground loading (ex. on first load)
                        debounce={1500}         // debounce multiple requests (i.e. as user types in filter box)
                        interval={this.state.refresh}     // update every 10 seconds
                        method="get"
                        endpoint="api/log/adp"
                        paused={!doRefresh}
                        params={params}
                    >
                        { (request: any) => {
                            // save the refresh function for later use
                            this.dataRefresh = request.refresh;

                            return <ReactTable
                                className="transaction-log -striped -highlight outside-scroll"
                                pivotBy={this.state.groupby}
                                onFetchData={request.refresh}
                                data={(request.data && request.data.entries) ? request.data.entries : []}
                                columns={columns}
                                defaultPageSize={16}
                                PaginationComponent={CustomPagination}
                                NoDataComponent={request.spinner ? () => null : undefined}
                                defaultSorted={[
                                    {
                                        id: 'timestamp',
                                        desc: true
                                    }
                                ]}
                            />;
                        }}
                    </DataRequest>

                    <Modal
                        style={inlineStyle.modal}
                        open={this.state.openModal}
                        onClose={this.handleModalClose}
                        size="mini"
                    >
                        <Modal.Header>Clear Log</Modal.Header>
                        <Modal.Content>{this.state.modalText}</Modal.Content>
                        <Modal.Actions>
                            <Button onClick={this.handleModalClose}>OK</Button>
                        </Modal.Actions>
                    </Modal>
                </div>
            </div>
        );
    }

    handleModalClose() {
        this.setState({
            openModal: false
        });
    }

    handleEventTypeCheckbox(e: any, data: any, option: any, entryTypeOptions: any) {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);

        let tempFilterArray: string[] = this.state.eventTypeFilter;
        let tempFilterTextArray: string[] = this.state.eventTypeFilterText;
        let tempOptionsArray: object[] = entryTypeOptions;
        tempOptionsArray.shift();
        let tempOptionsStringArray: string[] = tempOptionsArray.map((a: any) => a.value);
        let tempOptionsArrayText: string[] = tempOptionsArray.map((a: any) => a.text);

        if ( option.value === 'all') {
            this.setState({eventTypeFilterAll: data.checked});
            // tslint:disable-next-line:no-unused-expression
            data.checked ?
                (tempFilterArray = tempOptionsStringArray) && (tempFilterTextArray = tempOptionsArrayText)  :
                (tempFilterArray = []) && (tempFilterTextArray = []);
        } else {
            // tslint:disable-next-line:no-unused-expression
            data.checked ?
                tempFilterArray.push(option.value) && tempFilterTextArray.push(option.text) :
                (tempFilterArray = tempFilterArray.filter(item => item !== option.value)) &&
                (tempFilterTextArray = tempFilterTextArray.filter(item => item !== option.text));
        }
        // console.log(tempFilterTextArray);
        this.setState({ eventTypeFilter: tempFilterArray, eventTypeFilterText: tempFilterTextArray});
    }

    fetchAssets() {
        let _this = this;
        let url = 'http://default/api/vod/status';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.status) {
                    // SAN-2610 Since status.active may be false when we are in continuous mode but in-between passees,
                    // we must use this logic to determine if we should show the VOD or Live asset list.
                    const status = response.data.status;
                    if (!status.enabled && (status.mode === 'continuous' || (status.active))) {
                        _this.fetchVODAssetVariants();
                    } else if (status.mode === 'continuous' || (status.active)) {
                        _this.fetchVODAssetVariants();
                    } else {
                        _this.fetchAssetVariants();
                    }
                } else
                    throw response;
            })
            .catch(function (error: AxiosRequestConfig) {
                _this.fetchAssetVariants();
                // tslint:disable-next-line:no-console
                console.log('fetchAssetVariants() error: ', error);
            });
    }

    fetchVODAssetVariants() {
        let _this = this;
        let url = 'http://default/api/vod/aliases';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.vodAliases !== undefined) {

                    let nameArr = _.map((response.data.vodAliases), (i: any) => _.pick(i, 'name', 'streamId'));
                    // Taking only name and streamid out of response
                    let assetVar = [];

                    // tslint:disable-next-line:forin
                    for (let j in nameArr) {
                        assetVar.push({key: nameArr[j].streamId, value: nameArr[j].name, text: nameArr[j].name});
                    }
                    assetVar = assetVar.sort( function( a: any, b: any ) {
                        return a.text.toLowerCase().localeCompare(b.text.toLowerCase());      // Sorting alphabetically
                    });
                    assetVar.unshift({key: 0, value: '', text: 'ALL'});
                    _this.setState({
                        assetVariants: assetVar
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of VOD variants, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchVODAssetVariants() error: ', error);
            });
    }

    fetchAssetVariants() {
        let _this = this;
        let url = 'http://default/api/stream/status?streams=all';
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.streams !== undefined) {

                    let nameArr = _.map((response.data.streams), (i: any) => _.pick(i, 'name', 'streamid'));
                                                                                                // Taking only name and streamid out of response
                    let assetVar = [];

                    // tslint:disable-next-line:forin
                    for (let j in nameArr) {
                        assetVar.push({key: nameArr[j].streamid, value: nameArr[j].name, text: nameArr[j].name});
                    }
                    assetVar = assetVar.sort( function( a: any, b: any ) {
                        return a.text.toLowerCase().localeCompare(b.text.toLowerCase());      // Sorting alphabetically
                    });
                    assetVar.unshift({key: 0, value: '', text: 'ALL'});
                    _this.setState({
                        assetVariants: assetVar
                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of variants, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchAssetVariants() error: ', error);
            });
    }

    tooltipRenderer() {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={250} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }

    eventRenderer(props: any) {
        let clsName = 'eventType';

        if (props.original.type === 'info') {
            clsName = 'iq-td-status-info';
        }
        if (props.original.type === 'WARNING') {
            clsName = 'iq-td-alarm-major';
        } else
            if (props.original.type === 'ERROR') {
            clsName = 'iq-td-alarm-critical';
        }

        return (
            <div className={clsName} data-tip={props.value}>
                {props.value}
                {this.tooltipRenderer()}
            </div>);
    }

    nameRenderer(value: any) {
        return (
            <div data-tip={value}>
                {value}
            </div>);
    }

    detailRenderer(value: any) {
        return (
            <div data-tip={value} className="text-wrap">
                {value}
            </div>);
    }

    clearLog() {
        axios.delete('http://default/api/log/adp', {
        }).then((response: AxiosResponse) => {
            if ((response.data !== undefined) && (response.data.code === 'SUCCESS')) {
                this.setState({ openModal: true, modalText: 'Log Cleared' });
                this.dataRefresh();
            }
        }).catch((error: AxiosRequestConfig) => {
            this.setState({ openModal: true, modalText: 'Operation Failed.' });
        });
    }

    exportLog(oauth: OAuthClientStatus) {
        let _this = this;

        // SAN-5053: Disable export button.
        this.setState({
          exportBtnDisabled: true
        });

        const { startDate, endDate, assetFilter, eventTypeFilter, assetVariants } = this.state;
        let now = new Date(); let filename = '';
        // let url = (oauth.secureHost ? 'https' : 'http') + '://' + oauth.host +  '/adplog/TransactionLog_';
        let url = (oauth.secureHost ? 'https' : 'http') + '://default/api/export';
        let sysName = (oauth.sys.name ? oauth.sys.name : 'surveyor-abr');
        // sysName = encodeURIComponent(sysName);

        filename += 'IQTransactionLog-' + sysName + '-';

        filename += (now.getFullYear() + ('0' + (now.getUTCMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2));
        filename += '-';
        filename += (('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2) + ('0' + now.getSeconds()).slice(-2));
        filename += '.tsv';

        // fetch stream object
        const stream = assetVariants && assetVariants.filter((word: any) => word.key > 0 && word.value === assetFilter);

        // convert the array of strings in eventTypeFilter to a numeric mask
        // const eventTypeMask = eventTypeFilter.reduce( (acc: number, current: string) => {
        //     switch (current) {
        //         case 'error': return acc + 0x01;
        //         case 'warning': return acc + 0x02;
        //         case 'info': return acc + 0x04;
        //         case 'detail': return acc + 0x08;
        //         case 'all': return acc + 0x0f;
        //         default: return acc;
        //     }},                                       0);

        // build query parameters from filters
        const params = new RequestParameters({
            stream: Array.isArray(stream) && stream.length > 0 && stream[0].key || undefined,
            // filter: eventTypeMask || undefined,
            dataType: 'AdpLog',
            exportFormat: 'tsv',
            filename: filename,
            timerange: new TimeRange({from: startDate, to: endDate}),
            type: (eventTypeFilter.length > 0) ? eventTypeFilter : undefined,
            name: assetFilter
        }).queryString();

        if (params.length > 0)
            url += '?' + params;

        axios.post(url)
            .then(function (response: AxiosResponse) {
                let stringObject = response.data;

                // tslint:disable-next-line:no-shadowed-variable
                const { oauth, key } = OAuth.getContextFromResponseObject(response);
                if (oauth) {
                    oauth.waitforServer({
                        message: 'Exporting...please wait.'
                    },                  key)
                        .then(() => {
                            _this.setState({exportBtnDisabled: false});
                            fileDownload(stringObject, filename);
                        })
                        .catch( er => {
                            // SAN-5053: Enable export button.
                            _this.setState({exportBtnDisabled: false});
                            // tslint:disable-next-line:no-console
                            console.log(er);
                        });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('Not Authorized!');
                    // SAN-5053: Enable export button.
                    _this.setState({exportBtnDisabled: false});
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('Export Transaction Log error: ', error);
                // SAN-5053: Enable export button.
                _this.setState({exportBtnDisabled: false});
            });
    }

    private handleFilter() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);
    }
    private handleReset() {
        let prevRefreshRate = this.state.refresh;
        this.setRefreshInterval(1000);
        setTimeout(() => this.setState({refresh: prevRefreshRate}), 2000);

        this.setState({
            startDate: '',
            endDate: '',
            assetFilter: '',
            eventTypeFilter: []
        });
    }

    private toggleRefreshHandler () {
        const doesRefresh = this.state.doRefresh;
        let btnText = this.state.buttonText;
        if (btnText === 'Update') {
            btnText = 'Pause';
        } else {
            btnText = 'Update';
        }

        this.setState( {
            doRefresh: !doesRefresh,
            buttonText: btnText
        } );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/logs/transactionlog.tsx